import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Selector from '../../components/forms/Selector';
import language from '../../variables/language';
import * as api from './api';
import DraftComposer from './DraftComposer';
import '../../css/exercise-create-modal.css';

// Section 1 is the basics. Sections 2-4 (image, text, AI draft) are the shared
// DraftComposer. Only the footer is fixed; the body scrolls.
export default function ExerciseTemplateCreateModal({ isOpen, onClose, onCreated }) {
   const navigate = useNavigate();
   const lang = language[language.lang];
   const t = lang.screenshotImport;

   const [name, setName] = useState('');
   const [level, setLevel] = useState('');
   const [draft, setDraft] = useState(null);
   const [saving, setSaving] = useState(false);
   const [saveError, setSaveError] = useState('');

   if (!isOpen) return '';

   const resetAll = () => {
      setName(''); setLevel(''); setDraft(null);
      setSaving(false); setSaveError('');
   };

   const handleClose = () => {
      resetAll();
      onClose();
   };

   const finish = (template) => {
      resetAll();
      onCreated(template);
   };

   const submit = (e) => {
      e.preventDefault();
      if (saving) return;
      const finalName = name.trim() || (draft && draft.exerciseName ? draft.exerciseName.trim() : '');
      if (!finalName) return;
      setSaving(true);
      setSaveError('');
      if (draft) {
         axios.post('/api/exercise-ocr/materialize',
               { name: finalName, levelId: level || null, draft },
               { withCredentials: true })
            .then(response => {
               const exerciseId = response.data && response.data.exerciseId;
               if (exerciseId) finish({ id: exerciseId });
            })
            .catch(err => {
               if (err.response && err.response.status === 401) navigate('/login');
               setSaveError(t.createFailed);
            })
            .finally(() => setSaving(false));
         return;
      }
      const payload = { name: finalName };
      if (level) payload.level = level;
      api.createExerciseTemplate(payload)
         .then(response => finish(response.data))
         .catch(err => {
            if (err.response && err.response.status === 401) navigate('/login');
            setSaveError(t.createFailed);
         })
         .finally(() => setSaving(false));
   };

   const canSubmit = !saving && (name.trim() || (draft && draft.exerciseName && draft.exerciseName.trim()));

   return (
      <div className='ecm-overlay' onClick={handleClose}>
         <form className='ecm-panel' onClick={e => e.stopPropagation()} onSubmit={submit}>
            <header className='ecm-header'>
               <h3 className='ecm-title'>
                  <span className='material-symbols-outlined ecm-title-icon'>note_add</span>
                  Новий шаблон вправи
               </h3>
               <button type='button' className='ecm-close' onClick={handleClose} aria-label='Закрити'>×</button>
            </header>

            <div className='ecm-body'>
               <section className='ecm-section' style={{ '--accent': '#7ec2e8' }}>
                  <h4 className='ecm-section-title'>
                     <span className='material-symbols-outlined ecm-section-icon'>tune</span>
                     1. Основне
                  </h4>
                  <div className='ecm-row'>
                     <label className='ecm-field'>
                        <span>{lang.name}</span>
                        <input type='text' value={name} onChange={e => setName(e.target.value)} placeholder={lang.name} />
                     </label>
                     <label className='ecm-field'>
                        <span>{lang.level}</span>
                        <Selector className='ecm-select' name='level' url='/api/levels' value={level} disabled={false}
                           selectorsHundler={(value) => setLevel(value)} />
                     </label>
                  </div>
               </section>

               <DraftComposer onDraftChange={setDraft} />
            </div>

            <footer className='ecm-footer'>
               {saveError ? <span className='ecm-error'>{saveError}</span> : ''}
               <button type='button' className='ecm-btn' onClick={handleClose}>{t.cancel}</button>
               <button type='submit' className='ecm-btn ecm-btn-primary' disabled={!canSubmit}>
                  {saving ? t.creating : (draft ? t.createExercise : lang.save)}
               </button>
            </footer>
         </form>
      </div>
   );
}
